import {
  GET_SIGNED_URL,
  GET_VEHICLE_VIDEO_TRACKER_BY_VEHICLE_ID,
} from '@/services/api/trackvideo/video'
import { GET_VEHICLE_DETAILS } from '@/services/api/vehicle/vehicleDetail'
import {
  GET_DEVICE_MEDIA,
  GET_DEVICE_STREAM,
  GET_DOWNLOAD_VIDEO_HISTORIES,
  GET_VEHICLE_VIDEO,
  GET_VEHICLE_VIDEOS,
  GET_VEHICLE_VIDEOS_TV2,
} from '@/services/api/videoHistory/videos'
import { client } from '@/services/apolloclient'
import moment from 'moment'
import { Helper } from '@/mixin/helper'
import store from '../store'
import {
  SET_DEVICE_STREAM,
  SET_UPLOAD_MEDIA,
  SET_VIDEO_STREAM_STATUS,
  UPDATE_FILELIST,
} from '@/services/api/onlineCommand'

export const state = {
  vehicleId: null,
  vehicleDetail: {
    licensePlate: null,
    vehicleType: null,
    vehicleCategory: null,
    manufacturer: null,
    imei: null,
    deviceName: null,
    id: null,
  },

  statusText: null,
  videoState: 'noVideo',
  source: null,
  uploadVideo: {
    mediaFilename: '',
    isUploaded: false,
    isLoading: true,
    message: '',
  },
  vehicleVideos: [],
  lastUpdate: null,
  startTime: '',
  camera: '',
  cameraLabel: '',
  channelActive: null,
  cameraPosition: 1,
  period: [],
  periodTemp: [],
  deviceMedia: null,
  isLoadingVehicleVideos: false,
  pickVideo: null,
  isPlay: false,
  isMuted: false,
  isFullScreen: false,
  isStreamFromDevice: false,
  isLoadingVideo: true,
  videoStatus: '',
  streamStatus: {
    source: '',
    status: '',
  },
  streamChanged: '',
  videoStates: {
    isPlaying: false,
    isLoading: false,
    isVideoStopped: false,
    isShowThumbnail: false,
    src: null,
    isDownloaded: null,
    status: '',
  },
  /**
   * key is downloadId
   * value is interface like this
   * licensePlate: string
   * convertedChannel: number
   * startTime: string
   * endTime: string
   * downloadOn: string
   * status: 'S' | 'I' | 'F'
   * deviceTimezone: number
   * downloadId: number
   **/
  dvhPollingData: {},
  showWidgetDownload: false,
  isLoadingDownloadVideoHistoriesWidget: false,
  indexVideoActive: null,
  timePlaybackActive: null,
  downloadVideoPerItemStatus: [],
  isRequestOnlineCommandTv1: false,
  playbackUidActive: null,
  playbackUidActiveTv1: null,
  deviceTimezone: null,
  isFileListFromRedis: false,
  lastFilelistStartTime: null,
  isVideoHasBeenPaused: false,
  listVehicle: [],
  listVgroups: [],
  listVehicleType: [],
  tempVehicleStatuses: {},
  vehicleStatuses: {},
  loadingVideoStatus: false,
  streamingEndpoint: null,
  isLoadingVideoPlayer: false,
}

export const getters = {
  vehicleId: (state) => {
    return state.vehicleId
  },
  videoStates: (state) => {
    return state.videoStates
  },
  vehicleDetail: (state) => {
    return state.vehicleDetail
  },
  vehiclePeriod: (state) => {
    return state.period
  },
  vehicleCameraPosition: (state) => {
    return state.cameraPosition
  },
  isStreamFromDevice: (state) => {
    return state.isStreamFromDevice
  },
  isLoadingVideo: (state) => {
    return state.isLoadingVideo
  },
  pickVideo: (state) => {
    return state.pickVideo
  },
  streamChanged: (state) => {
    return state.streamChanged
  },
  streamVehicleStatus: (state) => {
    return state.streamStatus
  },
  isPlay: (state) => {
    return state.isPlay
  },
  videoIsMuted: (state) => {
    return state.isMuted
  },
  videoIsFullScreen: (state) => {
    return state.isFullScreen
  },
  videoStatus: (state) => {
    return state.videoStatus
  },
  vehicleVideoUpload: (state) => {
    return state.uploadVideo
  },
  isLoadingVehicleVideos: (state) => {
    return state.isLoadingVehicleVideos
  },
  vehicleVideoHistory: (state) => {
    return {
      vehicleVideos: state.vehicleVideos || [],
      lastUpdate: state.lastUpdate,
    }
  },
  vehicleStatusByVehicleId: (state) => (vehicleId) => {
    return state.vehicleStatuses[vehicleId]
  },
  tempVehicleStatusByVehicleId: (state) => (vehicleId) => {
    return state.tempVehicleStatuses[vehicleId]
  },
  isUsingWsFlv: (state, getters, rootState, rootGetters) => {
    if (!rootState.identity.whoami) return false
    if (state?.vehicleDetail?.deviceName === 'jc') return false
    const companyId = rootState.identity.whoami?.companyId
    const listCompany = rootGetters['identity/getFeatureFlagValue'](
      'trackvision_list_company_ws_flv'
    )

    return listCompany.includes(companyId)
  },
}

export const actions = {
  async requestVehicleDetail({ commit }, payload) {
    await client
      .query({
        query: GET_VEHICLE_DETAILS,
        variables: {
          filter: payload.filter,
        },
        fetchPolicy: 'no-cache',
      })
      .then((response) => {
        if (!response.data.vehicle.isSuccessful) return

        const vehicle = response.data.vehicle.vehicle
        const statusText = vehicle.sensor.find((x) => x.sensorCode === 35).statusText.split(',')
        const deviceName = Helper.methods.getDeviceType(vehicle.device.deviceCode)
        const vehicleDetail = {
          licensePlate: vehicle.licensePlate,
          vehicleType: vehicle.vehicleType.type,
          vehicleCategory: vehicle.vehicleType.category,
          imei: vehicle.imei,
          deviceName,
          deviceCode: vehicle.device.deviceCode,
          id: vehicle.id,
        }

        commit('setVehicleDetail', {
          vehicleDetail,
        })

        commit('setStatusText', statusText)
      })
      // eslint-disable-next-line no-console
      .catch((err) => console.error(err))
  },

  async requestVehicleVideoTrackerByVehicleId({ commit }, vehicleId) {
    await client
      .query({
        query: GET_VEHICLE_VIDEO_TRACKER_BY_VEHICLE_ID,
        variables: {
          filter: {
            vehicleId,
          },
        },
        fetchPolicy: 'no-cache',
      })
      .then((response) => {
        if (!response.data.vehicleVideoTrackers.isSuccessful) return
        const parent = response.data.vehicleVideoTrackers.vehicleVideoTrackers[0].parent
        const vehicle = response.data.vehicleVideoTrackers.vehicleVideoTrackers[0].vehicle
        const deviceTimezone =
          response.data.vehicleVideoTrackers.vehicleVideoTrackers[0].vehicle.device.timezone
        const statusText = response.data.vehicleVideoTrackers.vehicleVideoTrackers[0].statusText
        const deviceName = Helper.methods.getDeviceType(vehicle.device.deviceCode)
        const streamingEndpoint =
          response.data.vehicleVideoTrackers.vehicleVideoTrackers[0].streamingEndpoint
        const vehicleDetail = {
          licensePlate: parent ? parent?.vehicle?.licensePlate : vehicle.licensePlate,
          vehicleType: vehicle.vehicleType.type,
          vehicleCategory: vehicle.vehicleType.category,
          manufacturer: vehicle.vehicleType.manufacturer,
          imei: vehicle.imei,
          deviceName,
          deviceCode: vehicle.device.deviceCode,
          id: vehicle.id,
        }

        commit('setVehicleDetail', {
          vehicleDetail,
        })
        commit('setStatusText', statusText)
        commit('setChannelActive', Number(statusText.split(',')[0]))
        commit('setDeviceTimezone', deviceTimezone)
        commit('setStreamingEndpoint', streamingEndpoint)
      })
      // eslint-disable-next-line no-console
      .catch((err) => console.error(err))
  },

  async requestVehicleVideo(_, payload) {
    try {
      const response = await client.query({
        query: GET_VEHICLE_VIDEO,
        variables: {
          filter: payload.filter,
        },
        fetchPolicy: 'no-cache',
      })

      if (!response.data.vehicleVideo.isSuccessful) return

      const data = response.data.vehicleVideo.vehicleVideo

      return data
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
    }
  },

  async requestVehicleVideos({ commit, state }, payload) {
    try {
      const response = await client.query({
        client: 'clientLowPrio',
        query: GET_VEHICLE_VIDEOS,
        variables: {
          filter: payload.filter,
        },
        fetchPolicy: 'no-cache',
      })

      if (!response.data.vehicleVideos.isSuccessful) {
        return
      }

      const data = response.data.vehicleVideos.vehicleVideos

      const deviceType = state.vehicleDetail.deviceName
      let dataFiles = []
      if (deviceType === 'bsj') {
        // Update starttime in first video
        const isFilterStarttimeBetweenFirstVideo = data.files.length
          ? Helper.methods.isBetweenDate(
              moment(payload.filter.startTime).local().format('YYYY-MM-DDTHH:mm:ss'),
              data.files[0].startTime,
              data.files[0].endTime
            )
          : false
        if (isFilterStarttimeBetweenFirstVideo) {
          data.files[0].startTime = moment(payload.filter.startTime)
            .local()
            .format('YYYY-MM-DDTHH:mm:ss')
        }

        // Update endtime in last video
        const isFilterEndtimeBetweenLastVideo = data.files.length
          ? Helper.methods.isBetweenDate(
              moment(payload.filter.endTime).local().format('YYYY-MM-DDTHH:mm:ss'),
              data.files[data.files.length - 1].startTime,
              data.files[data.files.length - 1].endTime
            )
          : false
        if (isFilterEndtimeBetweenLastVideo) {
          data.files[data.files.length - 1].endTime = moment(payload.filter.endTime)
            .local()
            .format('YYYY-MM-DDTHH:mm:ss')
        }

        // Make sure data show is based on filter ranges dateTimes
        dataFiles = data.files.filter((data) => {
          const _startTime = Helper.methods.formatDateToUtc(data.startTime)
          const _endTime = Helper.methods.formatDateToUtc(data.endTime)
          return (
            moment(_startTime).isAfter(payload.filter.startTime) &&
            moment(_endTime).isAfter(payload.filter.startTime) &&
            moment(_startTime).isBefore(payload.filter.endTime)
          )
        })
      } else if (deviceType === 'jc') {
        dataFiles = data.files
      }

      const groupedData = dataFiles
        // .filter((x) => !x.isDownloaded)
        .reduce((result, item) => {
          const date = new Date(item.startTime)
          const formattedHour = date.toISOString().slice(0, 13)

          result[formattedHour] = result[formattedHour] || []
          result[formattedHour].push({
            ...item,
            isStreaming: false,
            isLoading: false,
            time: moment(date).format('HH:mm:ss'),
          })

          return result
        }, {})

      const groupedVehicleVideos = Object.keys(groupedData)
        .map((hour) => {
          return {
            dateTime: moment(groupedData[hour][0].startTime).format('DD MMM YYYY - HH:00'),
            videos: groupedData[hour].sort((a, b) => a.time.localeCompare(b.time)),
          }
        })
        .sort((a, b) => a.videos[0].time.localeCompare(b.videos[0].time))

      commit('setVehicleVideos', {
        vehicleVideos: groupedVehicleVideos,
        lastUpdate: data.lastUpdate,
      })
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
    }
  },

  // eslint-disable-next-line no-unused-vars
  async requestVehicleVideosTv2({ commit, state }, payload) {
    try {
      const response = await client.query({
        client: 'clientLowPrio',
        query: GET_VEHICLE_VIDEOS_TV2,
        variables: {
          filter: {
            ...payload,
            useInMemoryDB: true,
            isFileSplitted: true,
          },
        },
        fetchPolicy: 'no-cache',
      })

      if (!response.data.vehicleVideos.isSuccessful) {
        return new Error(response.data.vehicleVideos.message)
      }

      const data = response.data.vehicleVideos.vehicleVideos

      return data
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
    }
  },

  async splitVehicleVideos({ commit, state }, { videoFiles, filter, lastUpdate }) {
    const deviceTimezone = state.deviceTimezone

    const deviceType = state.vehicleDetail.deviceName
    let dataFiles = []
    if (deviceType === 'bsj' || deviceType === 'vss-howen') {
      // // Update starttime in first video
      const isFilterStarttimeBetweenFirstVideo = videoFiles.length
        ? Helper.methods.isBetweenDate(
            Helper.methods.convertUtcToLocalDate(filter.startTime, deviceTimezone),
            videoFiles[0].startTime,
            videoFiles[0].endTime
          )
        : false
      if (isFilterStarttimeBetweenFirstVideo) {
        videoFiles[0].startTime = Helper.methods.convertUtcToLocalDate(
          filter.startTime,
          deviceTimezone
        )
      }
      // Update endtime in last video
      const isFilterEndtimeBetweenLastVideo = videoFiles.length
        ? Helper.methods.isBetweenDate(
            Helper.methods.convertUtcToLocalDate(filter.endTime, deviceTimezone),
            videoFiles[videoFiles.length - 1].startTime,
            videoFiles[videoFiles.length - 1].endTime
          )
        : false
      if (isFilterEndtimeBetweenLastVideo) {
        videoFiles[videoFiles.length - 1].endTime = Helper.methods.convertUtcToLocalDate(
          filter.endTime,
          deviceTimezone
        )
      }

      // Make sure data show is based on filter ranges dateTimes
      dataFiles = videoFiles.filter((data) => {
        const _startTime = Helper.methods.getUtcDateFromLocalDate(data.startTime, deviceTimezone)
        const _endTime = Helper.methods.getUtcDateFromLocalDate(data.endTime, deviceTimezone)
        return (
          new Date(_startTime) >= new Date(filter.startTime) &&
          new Date(_startTime) < new Date(filter.endTime)
        )
      })
    } else if (deviceType === 'jc') {
      dataFiles = videoFiles.filter((data) => {
        const _startTime = Helper.methods.getUtcDateFromLocalDate(data.startTime, deviceTimezone)
        const _endTime = Helper.methods.getUtcDateFromLocalDate(data.endTime, deviceTimezone)
        return (
          new Date(_startTime) >= new Date(filter.startTime) &&
          new Date(_startTime) < new Date(filter.endTime)
        )
      })
    }

    const groupedData = dataFiles
      // .filter((x) => !x.isDownloaded)
      .reduce((result, item) => {
        const date = new Date(item.startTime)
        const formattedHour = date.toISOString().slice(0, 13)
        result[formattedHour] = result[formattedHour] || []
        result[formattedHour].push({
          ...item,
          isStreaming: false,
          isLoading: false,
          time: moment(date).format('HH:mm:ss'),
          utcDateTime: date.toISOString(),
        })

        return result
      }, {})

    const groupedVehicleVideos = Object.keys(groupedData)
      .map((hour) => {
        return {
          dateTime: moment(groupedData[hour][0].startTime).format('DD MMM YYYY - HH:00'),
          videos: groupedData[hour].sort((a, b) => a.time.localeCompare(b.time)),
        }
      })
      .sort((a, b) => a.videos[0].utcDateTime.localeCompare(b.videos[0].utcDateTime))

    commit('setVehicleVideos', {
      vehicleVideos: groupedVehicleVideos,
      lastUpdate,
    })
  },

  setVehicleVideosDemo(
    { commit, state },
    /**
     *
     * @param vehicleId vehicleId in string number format
     * @param channel example: 01, 02, 03, etc
     */
    { vehicleId, channel }
  ) {
    const date = state.period[0].split(' ')[0]
    const isYesterday = moment(date).isSame(moment().subtract(1, 'days'), 'day')

    if (!isYesterday) {
      commit('setVehicleVideos', {
        vehicleVideos: [],
        lastUpdate: Helper.methods.now(),
      })
      return
    }

    channel = parseInt(channel)
    const dataDemoVideoHistory = JSON.parse(
      store.state.identity.featureFlag.find(
        (feature) => feature.key == 'vsms2_trackvision2_playback_demo_id'
      ).value
    )
    const videoDemo = dataDemoVideoHistory[vehicleId][channel - 1]

    const hours = []
    videoDemo.forEach((videoFile) => {
      const fileName = videoFile.split('.')[0]
      const hour = parseInt(fileName.split('_')[fileName.split('_').length - 3])
      if (!hours.includes(hour)) {
        hours.push(hour)
      }
    })

    const groupedData = hours.map((hour) => {
      const date = state.period[0].split(' ')[0]
      return {
        dateTime: moment(date + `T${Helper.methods.addLeadingZero(hour)}:00`).format(
          'DD MMM YYYY - HH:00'
        ),
        videos: videoDemo
          .filter((videoFile) => {
            const fileName = videoFile.split('.')[0]
            const _hour = parseInt(fileName.split('_')[fileName.split('_').length - 3])
            const _minute = parseInt(fileName.split('_')[fileName.split('_').length - 2])
            const _second = parseInt(fileName.split('_')[fileName.split('_').length - 1])
            const momentPeriodDate =
              moment(state.period[0]).year() +
              '-' +
              Helper.methods.addLeadingZero(moment(state.period[0]).month() + 1) +
              '-' +
              Helper.methods.addLeadingZero(moment(state.period[0]).date())
            const dateTimeVideo =
              momentPeriodDate +
              'T' +
              Helper.methods.addLeadingZero(_hour) +
              ':' +
              Helper.methods.addLeadingZero(_minute) +
              ':' +
              Helper.methods.addLeadingZero(_second)
            return Helper.methods.isBetweenDate(
              Helper.methods.formatDateToUtc(dateTimeVideo),
              Helper.methods.formatDateToUtc(state.period[0]),
              Helper.methods.formatDateToUtc(state.period[1])
            )
          })
          .map((videoFile) => {
            const fileName = videoFile.split('.')[0]
            const _hour = parseInt(fileName.split('_')[fileName.split('_').length - 3])
            const _minute = parseInt(fileName.split('_')[fileName.split('_').length - 2])
            const _second = parseInt(fileName.split('_')[fileName.split('_').length - 1])
            const time = `${Helper.methods.addLeadingZero(_hour)}:${Helper.methods.addLeadingZero(
              _minute
            )}:${Helper.methods.addLeadingZero(_second)}`
            return {
              channel,
              createdAt: Helper.methods.now(),
              isLoading: false,
              isStreaming: false,
              mediaFilename: videoFile,
              startTime: date + 'T' + time,
              time,
            }
          }),
      }
    })

    commit('setVehicleVideos', {
      vehicleVideos: groupedData.filter((data) => data.videos.length),
      lastUpdate: Helper.methods.now(),
    })
  },

  setVehicleVideosDemoV2(
    { commit, state, rootGetters },
    /**
     *
     * @param vehicleId vehicleId in string number format
     * @param channel channel based on statusText
     */
    { vehicleId, channel }
  ) {
    const deviceType = state.vehicleDetail.deviceName

    channel = deviceType === 'jc' ? Number(channel) + 1 : Number(channel)
    const dataDemoVideoHistory = rootGetters['identity/getFeatureFlagValue'](
      'vsms2_trackvision2_playback_demo_id'
    )

    const videoDemo = dataDemoVideoHistory[vehicleId][channel - 1]

    const hours = []
    videoDemo.forEach((videoFile) => {
      const fileName = videoFile.split('.')[0]
      const hour = parseInt(fileName.split('_')[fileName.split('_').length - 3])
      if (!hours.includes(hour)) {
        hours.push(hour)
      }
    })

    const groupedData = hours.map((hour) => {
      const date = Helper.methods.convertUtcToLocalDate(state.period[0], 7).split('T')[0]
      return {
        dateTime: moment(date + `T${Helper.methods.addLeadingZero(hour)}:00`).format(
          'DD MMM YYYY - HH:00'
        ),
        videos: videoDemo
          .filter((videoFile) => {
            const fileName = videoFile.split('.')[0]
            const _hour = parseInt(fileName.split('_')[fileName.split('_').length - 3])
            const _minute = parseInt(fileName.split('_')[fileName.split('_').length - 2])
            const _second = parseInt(fileName.split('_')[fileName.split('_').length - 1])
            const momentPeriodDate =
              moment(state.period[0]).year() +
              '-' +
              Helper.methods.addLeadingZero(moment(state.period[0]).month() + 1) +
              '-' +
              Helper.methods.addLeadingZero(moment(state.period[0]).date())
            const dateTimeVideo =
              momentPeriodDate +
              'T' +
              Helper.methods.addLeadingZero(_hour) +
              ':' +
              Helper.methods.addLeadingZero(_minute) +
              ':' +
              Helper.methods.addLeadingZero(_second)
            return Helper.methods.isBetweenDate(
              Helper.methods.formatDateToUtc(dateTimeVideo),
              Helper.methods.formatDateToUtc(state.period[0]),
              Helper.methods.formatDateToUtc(state.period[1])
            )
          })
          .map((videoFile) => {
            const fileName = videoFile.split('.')[0]
            const _hour = parseInt(fileName.split('_')[fileName.split('_').length - 3])
            const _minute = parseInt(fileName.split('_')[fileName.split('_').length - 2])
            const _second = parseInt(fileName.split('_')[fileName.split('_').length - 1])
            const time = `${Helper.methods.addLeadingZero(_hour)}:${Helper.methods.addLeadingZero(
              _minute
            )}:${Helper.methods.addLeadingZero(_second)}`
            return {
              channel,
              createdAt: Helper.methods.now(),
              isLoading: false,
              isStreaming: false,
              mediaFilename: videoFile,
              startTime: date + 'T' + time,
              time,
            }
          }),
      }
    })

    commit('setVehicleVideos', {
      vehicleVideos: groupedData.filter((data) => data.videos.length),
      lastUpdate: Helper.methods.now(),
    })
  },

  async getSignedUrlVideoDemo({ state }, filename) {
    try {
      const response = await client.query({
        query: GET_SIGNED_URL,
        variables: {
          filter: {
            filename,
            identifier: state.vehicleDetail.deviceName === 'jc' ? 'jcDemo' : 'bsjDemo',
            vehicleId: state.vehicleDetail.id,
          },
        },
      })
      return response.data.getSignedUrl.getSignedUrl.url
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  },

  async requestUpdateFileList({ state }, payload) {
    const deviceName = state.vehicleDetail.deviceName
    let input = {}
    if (deviceName === 'jc') {
      input = payload.input
    } else {
      input = { ...payload.input, channel: state.channelActive }
      if (deviceName === 'vss-howen' || deviceName === 'bsj') {
        const startPeriod = state.period[0]
        const endPeriod = state.period[1]
        input['dateRange'] = { start: startPeriod, end: endPeriod }
      }
    }
    input['useInMemoryDB'] = true

    await client
      .mutate({
        mutation: UPDATE_FILELIST,
        variables: {
          input,
        },
        fetchPolicy: 'no-cache',
      })
      .then((response) => {
        if (!response.data.updateFileList.isSuccessful) return
      })

      // eslint-disable-next-line no-console
      .catch((err) => console.error(err))
  },

  async requestStreamFromDevice(_, payload) {
    try {
      const mutate = await client.mutate({
        mutation: SET_DEVICE_STREAM,
        variables: {
          input: payload,
        },
        fetchPolicy: 'no-cache',
      })

      return mutate.data.setDeviceStream
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
    }
  },

  async getDeviceStream(_, payload) {
    try {
      const response = await client.query({
        query: GET_DEVICE_STREAM,
        variables: {
          filter: payload,
        },
        fetchPolicy: 'no-cache',
      })

      return response.data.getDeviceStream
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
    }
  },

  async stopRTMPLiveStream(_, { imei }) {
    await client
      .mutate({
        mutation: SET_VIDEO_STREAM_STATUS,
        variables: {
          input: {
            status: false,
            imei: imei,
            camera: 'INOUT',
          },
        },
      })

      // eslint-disable-next-line no-console
      .catch((err) => console.error(err))
  },

  async updateStream({ commit, state }, { index, indexVideo, url, status }) {
    const video = state.vehicleVideos[index].videos[indexVideo]
    if (video) {
      switch (status) {
        case 'LOADING':
          commit('setPickVideo', { index, indexVideo })
          commit('updateVideoIsStreaming', { index, indexVideo, isStreaming: true })
          commit('updateVideoStates', {
            ...state.videoStates,
            isLoading: true,
            isPlaying: false,
            isDownloaded: video.isDownloaded,
            status,
          })
          break
        case 'SHOW_THUMBNAIL':
          commit('setPickVideo', { index, indexVideo })
          commit('updateVideoIsStreaming', { index, indexVideo, isStreaming: false })
          commit('updateVideoStates', {
            ...state.videoStates,
            src: url,
            isPlaying: false,
            isLoading: false,
            isShowThumbnail: true,
            isDownloaded: video.isDownloaded,
            status,
          })
          break
        case 'ATTACH_MEDIA':
          commit('setPickVideo', { index, indexVideo })
          commit('updateVideoIsStreaming', { index, indexVideo, isStreaming: true })
          commit('updateVideoStates', {
            ...state.videoStates,
            src: url,
            isPlaying: true,
            isShowThumbnail: false,
            isDownloaded: video.isDownloaded,
            status,
          })
          break
        case 'DETACH_MEDIA':
          commit('setPickVideo', { index, indexVideo })
          commit('updateVideoIsStreaming', { index, indexVideo, isStreaming: false })
          commit('updateVideoStates', {
            ...state.videoStates,
            src: null,
            isLoading: false,
            isPlaying: false,
            isVideoStopped: false,
            isDownloaded: video.isDownloaded,
            status,
          })
          break
        case 'PLAYING':
          commit('setPickVideo', { index, indexVideo })
          commit('updateVideoIsStreaming', { index, indexVideo, isStreaming: true })
          commit('updateVideoStates', {
            ...state.videoStates,
            isLoading: false,
            isPlaying: true,
            isShowThumbnail: false,
            isDownloaded: video.isDownloaded,
            status,
          })
          break
        case 'PLAY':
          commit('setPickVideo', { index, indexVideo })
          commit('updateVideoIsStreaming', { index, indexVideo, isStreaming: true })
          commit('updateVideoStates', {
            ...state.videoStates,
            isPlaying: true,
            isDownloaded: video.isDownloaded,
            status,
          })
          break
        case 'PAUSE':
          commit('setPickVideo', { index, indexVideo })
          commit('updateVideoIsStreaming', { index, indexVideo, isStreaming: false })
          commit('updateVideoStates', {
            ...state.videoStates,
            isPlaying: false,
            isLoading: false,
            isDownloaded: video.isDownloaded,
            status,
          })
          break
        case 'VIDEO_STOPPED':
          commit('setPickVideo', { index, indexVideo })
          commit('updateVideoIsStreaming', { index, indexVideo, isStreaming: false })
          commit('updateVideoStates', {
            ...state.videoStates,
            isPlaying: false,
            isVideoStopped: true,
            isDownloaded: video.isDownloaded,
            status,
          })
          break
        case 'REPLAY':
          commit('setPickVideo', { index, indexVideo })
          commit('updateVideoIsStreaming', { index, indexVideo, isStreaming: true })
          commit('updateVideoStates', {
            ...state.videoStates,
            src: null,
            isVideoStopped: false,
            isLoading: true,
            isPlaying: false,
            isDownloaded: video.isDownloaded,
            status,
          })
          break
        default:
          break
      }
    }
  },

  async requestGetDeviceMedia({ commit, state }, payload) {
    await client
      .query({
        query: GET_DEVICE_MEDIA,
        variables: {
          filter: payload.filter,
        },
        fetchPolicy: 'no-cache',
      })
      .then((response) => {
        if (response.data.deviceMedia.isSuccessful) {
          const data = response.data.deviceMedia.deviceMedia

          if (data.isDownloaded) {
            commit('setUploadVideoProcess', {
              ...state.uploadVideo,
              mediaFilename: data.mediaFilename,
              isLoading: false,
              isUploaded: true,
            })
          }
        }
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err)
      })
  },

  // eslint-disable-next-line no-unused-vars
  async requestSetUploadMedia({ commit }, payload) {
    let res = {
      isSuccessFull: false,
      data: null,
      message: '',
    }
    return await client
      .mutate({
        mutation: SET_UPLOAD_MEDIA,
        variables: {
          input: payload.input,
        },
      })
      .then(async (response) => {
        const responseMessage = response.data.setUploadMedia.setUploadMedia.message
        const dataDvh = response.data.setUploadMedia.setUploadMedia.data
        res['message'] = responseMessage
        if (!response.data.setUploadMedia.isSuccessful) {
          return res
        } else if (responseMessage === 'Sent') {
          res.isSuccessFull = true
          res.data = dataDvh
          return res
        }
      })
      // eslint-disable-next-line no-console
      .catch((err) => {
        console.error(err)
        return res
      })
  },

  async requestDownloadVideoHistories(_, payload) {
    try {
      const response = await client.query({
        query: GET_DOWNLOAD_VIDEO_HISTORIES,
        variables: {
          filter: payload.filter,
        },
        fetchPolicy: 'no-cache',
      })
      const data = response.data.downloadVideoHistories.downloadVideoHistories.data
      return data
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  },
}

export const mutations = {
  setVehicleId(state, payload) {
    state.vehicleId = payload
  },
  setVehicleHistoryPeriod(state, payload) {
    state.period = payload
  },
  setVehicleDetail(state, payload) {
    state.vehicleDetail = payload.vehicleDetail
  },
  setPickVideo(state, payload) {
    state.pickVideo = payload
  },
  setVehicleVideos(state, payload) {
    state.vehicleVideos = payload.vehicleVideos
    state.lastUpdate = payload.lastUpdate
  },
  setStatusText(state, payload) {
    state.statusText = payload
  },
  setVideoStatusDetail(state, payload) {
    state.videoState = payload
  },
  setSource(state, payload) {
    state.source = payload
  },
  setStartTime(state, payload) {
    state.startTime = payload
  },
  setCamera(state, payload) {
    state.camera = `CH${payload.channel}`
    state.cameraLabel = payload.camera
  },
  setChannelActive(state, payload) {
    state.channelActive = payload
  },
  setCameraPosition(state, payload) {
    state.cameraPosition = payload
  },
  setLoadingVehicleVideos(state, payload) {
    state.isLoadingVehicleVideos = payload
  },
  setDuplicatePeriod(state, _) {
    state.periodTemp = [...state.period]
  },
  setDuplicatePeriodTemp(state, _) {
    state.period = [...state.periodTemp]
  },
  setVideoStatus(state, payload) {
    state.videoStatus = payload
  },
  setPlay(state, payload) {
    state.isPlay = payload
  },
  setMute(state, payload) {
    state.isMuted = payload
  },
  setFullScreen(state, payload) {
    state.isFullScreen = payload
  },
  setUploadVideoProcess(state, payload) {
    state.uploadVideo = payload
  },
  setDeviceMedia(state, payload) {
    state.deviceMedia = payload
  },
  setIndexVideoActive(state, payload) {
    state.indexVideoActive = payload
  },
  setTimePlaybackActive(state, payload) {
    state.timePlaybackActive = payload
  },
  setPlaybackUidActive(state, payload) {
    state.playbackUidActive = payload
  },
  setPlaybackUidActiveTv1(state, payload) {
    state.playbackUidActiveTv1 = payload
  },
  setDeviceTimezone(state, payload) {
    state.deviceTimezone = payload
  },
  setIsFileListFromRedis(state, payload) {
    state.isFileListFromRedis = payload
  },
  setLastFilelistStartTime(state, payload) {
    state.lastFilelistStartTime = payload
  },
  setIsVideoHasBeenPaused(state, payload) {
    state.isVideoHasBeenPaused = payload
  },
  setListVehicle(state, payload) {
    state.listVehicle = payload
  },
  setListVgroups(state, payload) {
    state.listVgroups = payload
  },
  setListVehicleType(state, payload) {
    state.listVehicleType = payload
  },
  setVehicleStatuses(state, payload) {
    state.vehicleStatuses = payload
  },
  setTempVehicleStatusesByVehicleId(state, { vehicleId, data }) {
    state.tempVehicleStatuses[vehicleId] = data
  },
  setVehicleStatusesByVehicleId(state, { vehicleId, data }) {
    state.vehicleStatuses[vehicleId] = data
  },
  setLoadingVideoStatus(state, payload) {
    state.loadingVideoStatus = payload
  },
  setShowWidgetDownload(state, payload) {
    state.showWidgetDownload = payload
  },
  setStreamingEndpoint(state, payload) {
    state.streamingEndpoint = payload
  },
  addDvhPollingData(state, { downloadId, data }) {
    const temp = { ...state.dvhPollingData, [downloadId]: data }
    state.dvhPollingData = temp
  },
  updateDvhPollingData(state, { downloadId, data }) {
    const temp = {
      ...state.dvhPollingData,
      [downloadId]: { ...state.dvhPollingData[downloadId], ...data },
    }
    state.dvhPollingData = temp
  },
  resetTempVehicleStatuses(state) {
    state.tempVehicleStatuses = {}
  },
  resetDownloadVideoPerItemStatus(state) {
    state.downloadVideoPerItemStatus = []
  },
  addDownloadVideoPerItemStatus(state, payload) {
    state.downloadVideoPerItemStatus = [...state.downloadVideoPerItemStatus, payload]
  },
  removeDownloadVideoPerItemStatus(state, payload) {
    state.downloadVideoPerItemStatus = state.downloadVideoPerItemStatus.filter(
      (data) => data !== payload
    )
  },
  updateVideoStates(state, payload) {
    state.videoStates = payload
  },
  updateIsRequestOnlineCommandTv1(state, payload) {
    state.isRequestOnlineCommandTv1 = payload
  },
  updateStreamChanged(state, payload) {
    state.streamChanged = payload
  },
  updateVideoIsLoading(state, { index, indexVideo, isLoading }) {
    if (state.vehicleVideos[index] && state.vehicleVideos[index].videos[indexVideo]) {
      state.vehicleVideos[index].videos[indexVideo].isLoading = isLoading
    }
  },
  updateVideoIsStreaming(state, { index, indexVideo, isStreaming }) {
    if (state.vehicleVideos[index] && state.vehicleVideos[index].videos[indexVideo]) {
      state.vehicleVideos[index].videos[indexVideo].isStreaming = isStreaming
    }
  },
  updateStreamFromDevice(state, payload) {
    return (state.isStreamFromDevice = payload)
  },
  updateVehicleVideo(state, { index, indexVideo, video }) {
    if (state.vehicleVideos[index] && state.vehicleVideos[index].videos[indexVideo]) {
      state.vehicleVideos[index].videos[indexVideo] = video
    }
  },
  updateLoadingDownloadVideoHistoriesWidget(state, payload) {
    state.isLoadingDownloadVideoHistoriesWidget = payload
  },
  clearStatusText(state) {
    state.statusText = null
  },
  clearVehicleId(state) {
    state.vehicleId = null
  },
  clearVehicleDetail(state) {
    state.vehicleDetail = {
      licensePlate: null,
      vehicleType: null,
      vehicleCategory: null,
      manufacturer: null,
      imei: null,
      deviceName: null,
      id: null,
    }
  },
  clearVehicleVideos(state) {
    state.vehicleVideos = null
    state.lastUpdate = null
  },
  clearPeriod(state) {
    state.period = []
    state.periodTemp = []
  },
  clearPickVideo(state) {
    state.pickVideo = null
  },
  clearVideoStates(state) {
    state.videoStates = {
      isPlaying: false,
      isLoading: false,
      isVideoStopped: false,
      isShowThumbnail: false,
      src: null,
      isDownloaded: null,
      status: '',
    }
  },
  setIsLoadingVideoPlayer(state, payload) {
    state.isLoadingVideoPlayer = payload
  },
}
